import {createMuiTheme,CssBaseline,MuiThemeProvider,} from "@material-ui/core";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import { SnackbarProvider, useSnackbar } from "notistack";
import * as React from "react";
import { Provider } from "react-redux";
import { Route } from "react-router";
import SnackbarComs from "./components/Commons/Alert/SnackbarComs";

import "./custom.css";
import Layout from "./layout/CommonLayout/Layout";
import RoutesComponent from "./router/RoutesComponent";
import configureStore from "./store/configureStore";

// Create browser history to use in the Redux store
const baseUrl = document
  .getElementsByTagName("base")[0]
  .getAttribute("href") as string;
const history = createBrowserHistory({ basename: baseUrl });
const store = configureStore(history);

export function getHistory() {
  return history;
}

export default function App(props) {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <RoutesComponent />
      </ConnectedRouter>
    </Provider>
  );
}

function AppWithSnackbar(props) {
  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    // this is a little hack to not have to import notistack
    // on all the components that emit messages
    SnackbarComs.registerNotistakEnqueueSnackbar(enqueueSnackbar);
  }, [enqueueSnackbar]);

  return (
    <>
      <ConnectedRouter history={history}>
        <RoutesComponent />
      </ConnectedRouter>
    </>
  );
}
